import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from '../../core/services/language.service';
@Pipe({
  name: 'translate',
  standalone: true,
  pure: false, // Enables dynamic updates
})
export class TranslationPipe implements PipeTransform {
  private translations: { [key: string]: any } = {};

  constructor(private http: HttpClient, private languageService: LanguageService) {
    // Subscribe to language changes
    this.languageService.getLanguage().subscribe(lang => {
      this.loadLanguage(lang);
    });
  }

  private loadLanguage(lang: string) {
    this.http.get(`/language/${lang}/common.json`).subscribe((data) => {
      this.translations = data;
    });
  }

  transform(key: string): string {
    return this.translations[key] || key;
  }
}
